import * as React from "react"
import {
  IconBolt,
} from "@tabler/icons-react"

import { NavMain } from "@/components/nav-main"
import { NavSecondary } from "@/components/nav-secondary"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

import { useAppSelector } from "@/store"
import { getNavForRole, getSecondaryNav } from "@/nav"

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const user = useAppSelector((state) => state.user)
  const org = useAppSelector((state) => state.organization)
  const { role } = useAppSelector((state) => state.role)
  const { permissions } = useAppSelector((state) => state.permissions)
  const { features } = useAppSelector((state) => state.features)
  const mainNav = getNavForRole(role, permissions, features)
  const secondary = getSecondaryNav(permissions)

  return (
    <Sidebar collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="app-brand"
            >
              <a href="#">
                <span className="app-brand-mark"><IconBolt className="size-5" /></span>
                <span className="app-brand-name">{org.name}<small>Client Management</small></span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={mainNav} />
        <NavSecondary items={secondary} className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={{
          name: user.name ?? "User",
          email: user.email ?? "",
          avatar: user.avatar ?? "",
        }} />
      </SidebarFooter>
    </Sidebar>
  )
}
